import React from "react";
import { withRouter } from "react-router";
import i18n from "../../../../i18n/i18n";
import { CompanyModel } from "../../../models/company";
import { CompanyService } from "../../../services/companyService";
import ModifyItem from "../../dictionary/modifyItem/modifyItem";
import CompanyForm from "../companyForm/companyForm";

class ModifyCompany extends ModifyItem<CompanyModel> {
    constructor(props: any) {
        super(props);
    }

    async componentDidMount() {
        this.getItem(await CompanyService.getCompany(this.props.match.params?.id));
    }

    render() {
        return(
            <div className="modify-company modify-record">
                <div className="content">
                    {this.renderHeader(i18n.t("dictionaries.companies.actions.modifyCompany.header"))}
                    {this.renderContent(<CompanyForm isUpdate={true} companyData={this.state.item}/>)}
                </div>
            </div>
        );
    }
}
export default withRouter(ModifyCompany);
